AuthRoute = require 'mixins/authenticated-route'

App.BannersCreateRoute = Em.Route.extend AuthRoute,
  controllerName: 'banners.edit'
  templateName:   'banners.edit'

  session: Em.inject.service()

  model: ->
    organization = @get('session.currentOrganization')

    unless organization
      return Em.RSVP.reject 'No current organization context found'


    @store.createRecord 'banner',
      name: ''
      organization: organization
